import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { shiftService } from '@/api/services/shiftService'
import { createApiRetryHandler } from '@/utils/apiRetry'
import type {
  ShiftDefectsListParams,
  ShiftDefectsListResponse,
  ShiftDefectActionPayload,
  ShiftDefectActionResponse,
} from '@/types/api/shifts'

export const SHIFT_DEFECT_QUERY_KEYS = {
  all: ['shift-defects'] as const,
  lists: () => [...SHIFT_DEFECT_QUERY_KEYS.all, 'list'] as const,
  list: (params: ShiftDefectsListParams) =>
    [...SHIFT_DEFECT_QUERY_KEYS.lists(), params] as const,
}

export const useShiftDefects = (params: ShiftDefectsListParams = {}) => {
  return useQuery<ShiftDefectsListResponse>({
    queryKey: SHIFT_DEFECT_QUERY_KEYS.list(params),
    queryFn: () => shiftService.listShiftDefects(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    retry: createApiRetryHandler(3),
  })
}

export const useShiftDefectAction = () => {
  const queryClient = useQueryClient()

  return useMutation<
    ShiftDefectActionResponse,
    Error,
    ShiftDefectActionPayload
  >({
    mutationFn: payload => shiftService.logShiftDefectAction(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SHIFT_DEFECT_QUERY_KEYS.all,
      })
    },
  })
}
